import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';

import React, { useCallback, useContext } from 'react';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { AllocationsGrid } from './allocations-grid';
import { BundleInventory } from './bundle';
import { LocationsGrid } from './locations-grid/';
import { messages as inventoryMessages } from './messages';
import { InventoryHistoryModal } from './modals/history';
import style from './style.module.less';
import { ToggleAndThreshold } from './toggle-and-threshold';
import { useEnableBundledProducts } from '../../../../../feature-flags/hooks/use-enable-bundled-products';
import { useModal } from '../../../../../hooks/use-modal';
import { BundleContext } from '../../../bundle-context';
import { ProductDetailsContext } from '../../../context';
import { messages } from '../../../messages';
import generalStyle from '../../../style.module.less';

export const ProductInventory = () => {
  const { isBundle } = useContext(BundleContext);
  const { productId, productSku } = useContext(ProductDetailsContext);
  const shouldShowBundles = useEnableBundledProducts();
  const { isOpen, open, close } = useModal();
  const shouldDisableButton = !productSku || productId === 0;

  const renderInventoryBody = useCallback(() => {
    if (isBundle && shouldShowBundles) {
      return <BundleInventory />;
    }

    return (
      <div className={style['product-inventory']}>
        <ToggleAndThreshold />
        <LocationsGrid />
        {isOpen ? <InventoryHistoryModal onCloseModal={close} /> : null}
        <Button disabled={shouldDisableButton} onClick={open} theme='link'>
          <div className={style['icon-wrapper']}>
            <span>
              <FontAwesomeIcon className={style['info-icon']} icon={faFileSpreadsheet} />
            </span>
            <span className={style['info-text']}>
              <FormattedMessage {...inventoryMessages.inventoryHistoryButton} />
            </span>
          </div>
        </Button>
        <AllocationsGrid />
      </div>
    );
  }, [shouldShowBundles, isBundle, close, open, isOpen, shouldDisableButton]);

  return (
    <>
      {!isBundle && (
        <div className={classnames(generalStyle['shipping-defaults-header-wrapper'], generalStyle.dropped, style['section-title'])}>
          <div className={classnames(generalStyle['shipping-defaults-header-text'], style['preferences-header'])}>
            <FormattedMessage {...messages.productInventoryPreferences} />
          </div>
        </div>
      )}
      {renderInventoryBody()}
    </>
  );
};
